import { converters as tableConverters } from 'store/table';
import { IAdminShopVoucher } from 'types/income';
import { convertBaseVoucher } from 'store/vouchers';
import { loaders } from './admin-shop-vouchers.loaders';
import { AdminShopVoucher } from './admin-shop-vouchers.types';

const convertShopVoucher = (voucher: IAdminShopVoucher): AdminShopVoucher => {
  return {
    ...convertBaseVoucher(voucher),
    shopItem: {
      id: voucher.marketplaceItemId,
      priceId: voucher.marketplaceItemPriceId,
    },
  };
};

const convertShopVouchers = (
  vouchers: IAdminShopVoucher[],
): AdminShopVoucher[] => {
  return vouchers.map(convertShopVoucher);
};

export const converters = {
  getShopVouchers: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getShopVouchers>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: convertShopVouchers(data.data),
      total,
      page,
      pageSize,
      pages,
    };
  },
  getShopVoucher: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getShopVoucher>>) => {
    return convertShopVoucher(data);
  },
};
